<template>
  <div class="container" id="goods-edit">
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <el-form
        ref="infoForm"
        label-width="100px"
        class="info-form"
        style="margin-top: 22px"
      >
        <el-form-item label="赠品说明">
          <div class="detail" v-html="detail.giveawayText"></div>
        </el-form-item>
        <el-form-item label="选择赠品">
          <el-table
            border
            :data="detail.interestGoods"
            :header-cell-style="{
              background: '#F5F6FA',

              color: '#303033',
            }"
            style="width: 651px"
          >
            <el-table-column
              label="排序"
              prop="type"
              align="center"
              width="80px"
            >
              <template slot-scope="props">
                <div style="text-align: center">{{ props.$index + 1 }}</div>
              </template>
            </el-table-column>
            <el-table-column label="商品名称" prop="type" align="left">
              <template slot="header">
                <div style="display: flex">
                  <div style="text-align: left">商品名称</div>
                </div>
              </template>
              <template slot-scope="props">
                <div style="text-align: left">{{ props.row.name }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="赠送个数"
              prop="type"
              align="center"
              width="120px"
            >
              <template slot-scope="props">
                <div style="text-align: center">{{ props.row.num }}</div>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="优惠券说明">
          <div class="detail" v-html="detail.couponText"></div>
        </el-form-item>
        <el-form-item label="选择优惠券">
          <el-table
            border
            :data="detail.interestCoupon"
            :header-cell-style="{
              background: '#F5F6FA',

              color: '#303033',
            }"
            style="width: 651px"
          >
            <el-table-column
              label="排序"
              prop="type"
              align="center"
              width="80px"
            >
              <template slot-scope="props">
                <div style="text-align: center">{{ props.$index + 1 }}</div>
              </template>
            </el-table-column>
            <el-table-column label="优惠券名称" prop="type" align="left">
              <template slot="header">
                <div style="display: flex">
                  <div style="text-align: left">优惠券名称</div>
                </div>
              </template>
              <template slot-scope="props">
                <div style="text-align: left">{{ props.row.name }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="赠送张数"
              prop="type"
              align="center"
              width="120px"
            >
              <template slot-scope="props">
                <div style="text-align: center">{{ props.row.num }}</div>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item> </el-form-item>
      </el-form>
    </div>
    <div class="back-btn">
      <el-button type="info" @click="back">返回</el-button>
    </div>
  </div>
</template>

<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
  },
  data () {
    return {
      expireDates: [
        {
          dictId: 1,
          dictName: '一个月'
        },
        {
          dictId: 3,
          dictName: '三个月'
        },
        {
          dictId: 12,
          dictName: '一年'
        },
        {
          dictId: 0,
          dictName: '永久'
        },
      ],
      dataList: {
        list: [
          { title: '营销管理', path: '', type: '0' },
          { title: '会员管理', path: '', type: '1' }
        ]
      },
      searchList: {
        list: [
          { title: '会员权益', path: '', type: '0' }
        ]
      },
      checked1: true,
      checked2: false,
      radio: 3,
      name: '---',
      dialogUser: false,
      currentPage4: 1,
      tableData: [

      ],
      tableDataF: [

      ],
      detail: {},
      arr: []
    }
  },
  created () {
    this.getDetail()
  },

  methods: {
    back () {
      this.$router.go(-1)
    },
    select () {
      console.log(this.arr)
    },
    getDetail () {
      this.axios.get('users/membersInfo?id=' + this.$route.query.id)
        .then(res => {
          if (res.code == 0) {
            res.data.price = res.data.price.toFixed(2)
            this.detail = res.data
            this.$forceUpdate()
          }
        })
    },
    handleCurrentChange () {

    },
    handleSizeChange () {

    },
    handleSelectionChange () {

    }
  }
}
</script>
<style scoped lang="scss">
/deep/ .el-table {
  tr th,
  tr td {
    border-right: none;
  }
}
::v-deep .el-input.is-disabled .el-input__inner {
  background-color: #ebeefa;
  border-color: #c0c0cc;
  color: #c0c4cc;
  cursor: not-allowed;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  text-align: left !important;
}
.detail {
  width: 378px;
  min-height: 112px;
  background: #ebeefa;
  border: 1px solid #c0c0cc;
  opacity: 1;
  border-radius: 3px;
  padding: 10px 10px;
  line-height: 30px;
  color: #303033;
}
.s-label {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 40px;
  color: #303033;
  opacity: 1;
}
.start {
  width: 10px;
  height: 10px;
  background: #13ce4b;
  border-radius: 50%;
  opacity: 1;
  margin-top: 15px;
  margin-right: 5px;
}
.end {
  width: 10px;
  height: 10px;
  background: #f63c56;
  border-radius: 50%;
  opacity: 1;
  margin-top: 15px;
  margin-right: 5px;
}
.dialog-search {
  display: flex;
  width: 46%;
  justify-content: space-between;
  margin-top: 10px;
  margin-left: 10px;
}
.back-btn {
  width: 30%;
  text-align: left;
  padding-bottom: 20px;
  .el-button {
    width: 184px;
    height: 48px;
    border-radius: 4px;
    font-size: 18px;
  }
}
</style>

